document.addEventListener('click', function (e) {
  var trigger = e.target.closest('.product-accordion__trigger');
  if (!trigger) {
    return;
  }

  var isOpen = trigger.getAttribute('aria-expanded') === 'true';
  var panel = document.getElementById(trigger.getAttribute('aria-controls'));
  if (!panel) {
    return;
  }

  trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
  panel.classList.toggle('is-open', !isOpen);
});
